export default "__VITE_ASSET__CSI5nEQ5__"